export function parsearArgumento(rawArg) {
  const arg = rawArg.trim()

  if (arg.startsWith('v:')) {
    return { tipo: 'variable', valor: arg.substring(2) }
  }

  if (arg.startsWith('i:')) {
    return { tipo: 'imagen', valor: arg.substring(2) }
  }

  if (arg.includes(':')) {
    return { tipo: 'funcion', valor: arg }
  }

  // LITERAL entre comillas o texto plano
  return {
    tipo: 'literal',
    valor: arg.replace(/^"|"$/g, ''),
  }
}

export function parsearArgumentosFuncion(cadena) {
  return cadena.split(',').map((a) => parsearArgumento(a))
}
